// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import target01Icon from "@/assets/icons/target-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Target01IconProps = Omit<IconProps, "name">;

export function Target01Icon(props: Target01IconProps): React.ReactNode {
  return <Icon name={target01Icon} {...props} />;
}
